import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentAllDelete = {
    path: "/consent/all",
    method: RouteHttpVerb.DELETE
};
